// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.nge-overlay-blocker {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  pointer-events: initial;
}
.ng-extend .modal.overlay-content.nge-overlay-content {
  min-width: 250px;
  background-color: #00000099;
  font-family: sans-serif;
  background: linear-gradient(90deg, #a46fe236, #a46fe214);
  border-radius: 20px;
  border: 5px solid #0000ff00;
  border-left: 5px solid #a46fe2ba;
  border-right: none;
  backdrop-filter: blur(2px);
}
.nge-overlay-content .title {
  font-size: 1.25em;
}
.nge-overlay.modal.overlay-content {
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalOverlay.vue"],"names":[],"mappings":";AAaA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,WAAW;EACX,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,uBAAuB;AACzB;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;EACvB,wDAAwD;EACxD,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;AAE5B;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["<script setup lang=\"ts\">\r\nimport Overlay from \"#src/components/Overlay.vue\";\r\n</script>\r\n\r\n<template>\r\n  <div class=\"nge-overlay-blocker\" @click.stop=\"$emit('hide')\" @mousedown.stop>\r\n    <overlay class=\"modal overlay-content nge-overlay-content\">\r\n      <slot></slot>\r\n    </overlay>\r\n  </div>\r\n</template>\r\n\r\n<style>\r\n.nge-overlay-blocker {\r\n  height: 100%;\r\n  width: 100%;\r\n  position: fixed;\r\n  z-index: 99;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  pointer-events: initial;\r\n}\r\n\r\n.ng-extend .modal.overlay-content.nge-overlay-content {\r\n  min-width: 250px;\r\n  background-color: #00000099;\r\n  font-family: sans-serif;\r\n  background: linear-gradient(90deg, #a46fe236, #a46fe214);\r\n  border-radius: 20px;\r\n  border: 5px solid #0000ff00;\r\n  border-left: 5px solid #a46fe2ba;\r\n  border-right: none;\r\n  backdrop-filter: blur(2px);\r\n\r\n}\r\n\r\n.nge-overlay-content .title {\r\n  font-size: 1.25em;\r\n}\r\n\r\n.nge-overlay.modal.overlay-content {\r\n  overflow: visible;\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
